module.exports = __webpack_public_path__ + "static/hotblack-events2-5131f25baa15185137dd9e7eef232243.jpg";